import { onReady } from '../base/init.js';

// Обратный отсчёт. Два режима:
//  - фиксированный: до даты из data-deadline ("YYYY-MM-DD HH:mm:ss" или ISO);
//    по достижении — обнуляется и останавливается.
//  - скользящий: data-period-days="N" — отсчёт до ближайшей границы N-суточного
//    цикла от точки отсчёта data-anchor (полночь). Никогда не «застывает» на нуле:
//    каждые N суток таймер автоматически перезапускается на N дней.
onReady(() => {
  const blocks = document.querySelectorAll('.js-countdown');
  if (!blocks.length) return;

  const DAY = 86400000;

  // "YYYY-MM-DD HH:mm:ss" парсим как локальное время (а не UTC), как и ISO-фолбэк.
  const parseDate = (str) => {
    const parts = str.split(/[-: T]/).map(Number);
    return parts.length >= 3
      ? new Date(parts[0], (parts[1] || 1) - 1, parts[2], parts[3] || 0, parts[4] || 0, parts[5] || 0)
      : new Date(str);
  };

  blocks.forEach((block) => {
    const periodDays = Number(block.getAttribute('data-period-days')) || 0;
    const raw = (block.getAttribute('data-deadline') || '').trim();

    // getDeadline возвращает целевой timestamp. В скользящем режиме он сам
    // «перескакивает» на следующую границу цикла, как только текущая пройдена.
    let getDeadline;
    if (periodDays > 0) {
      const period = periodDays * DAY;
      const anchorRaw = (block.getAttribute('data-anchor') || '').trim();
      const anchor = anchorRaw ? parseDate(anchorRaw) : new Date(2024, 0, 1, 0, 0, 0);
      if (Number.isNaN(anchor.getTime())) return;
      const anchorMs = anchor.getTime();
      getDeadline = () => {
        const cycles = Math.floor((Date.now() - anchorMs) / period) + 1;
        return anchorMs + cycles * period;
      };
    } else {
      if (!raw) return;
      const deadline = parseDate(raw);
      if (Number.isNaN(deadline.getTime())) return;
      getDeadline = () => deadline.getTime();
    }

    const els = {
      days: block.querySelector('.js-countdown-days'),
      hours: block.querySelector('.js-countdown-hours'),
      minutes: block.querySelector('.js-countdown-minutes'),
      seconds: block.querySelector('.js-countdown-seconds'),
    };

    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

    const render = () => {
      const rest = getDeadline() - Date.now();
      if (rest <= 0) {
        Object.values(els).forEach((el) => el && (el.textContent = '00'));
        if (periodDays <= 0) clearInterval(timer);
        return;
      }
      const days = Math.floor(rest / DAY);
      const hours = Math.floor((rest / 3600000) % 24);
      const minutes = Math.floor((rest / 60000) % 60);
      const seconds = Math.floor((rest / 1000) % 60);
      if (els.days) els.days.textContent = pad(days);
      if (els.hours) els.hours.textContent = pad(hours);
      if (els.minutes) els.minutes.textContent = pad(minutes);
      if (els.seconds) els.seconds.textContent = pad(seconds);
    };

    render();
    const timer = setInterval(render, 1000);
  });
});
